






















































































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '@/core/base.component';
import AuthService from '@/services/shared/auth/auth.service';
import NavList from '@/modules/_layouts/components/NavList.vue';
import routes from '@/router/component';
import { RouteConfig } from 'vue-router';
import store from '@/store/';
import { VUETIFY_THEME } from '../../services/shared';
@Component({
  name: 'MainLayout',
  components: {
    NavList,
  },
})
export default class MainLayout extends BaseComponent {
  private drawer = false;
  private mini = false;
  private routes: RouteConfig[] = routes;
  private keepAliveList = [
    'FounderCounsultList',
    'Dashboard',
    'NoticeBoard',
    'Company',
    'District',
    'Contracts',
    'QNA',
  ];
  get myName(): string {
    return store.state.myName;
  }
  get modifiedRoutes() {
    const tempArr = [];
    this.routes.map(e => {
      if (!e.meta.noNav) {
        tempArr.push(e);
      }
    });
    return tempArr;
  }
  logout() {
    AuthService.signout();
    this.$router.push('/login');
  }
  onThemeChanged() {
    // this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    let theme;
    if (this.$vuetify.theme.dark) {
      theme = 'DARK';
    } else {
      theme = 'LIGHT';
    }
    localStorage.setItem('theme', theme);
  }
  created() {
    // this.getNavItems();
    if (localStorage.theme) {
      if (localStorage.theme === VUETIFY_THEME.LIGHT) {
        this.$vuetify.theme.dark = false;
      } else {
        this.$vuetify.theme.dark = true;
      }
    } else {
      localStorage.setItem('theme', 'LIGHT');
    }
  }
}
